import { ref } from 'vue';
import type { GenericField } from '@Types';
import type { FieldInitialSettings, FieldSchema, RawField } from '@FormModule';
import { useForm } from '@FormModule';

const fieldsSchema = ref<FieldSchema[]>([]);

export default function () {
  const { getDetailsSchema } = useForm();

  const currentSchemaModels = ref<Set<GenericField>>(new Set());
  const fieldsSettings: FieldInitialSettings = {
    outcome_date: {
      model: new Date(),
      settings: {
        minDate: new Date(),
      },
    },
  };
  const rawFields = ref<RawField[]>([
    {
      label: 'Outcome Date',
      name: 'outcome_date',
      required: true,
      type: 'date',
      value: '',
    },
  ]);

  function setForm(oldestIntakeDate: number) {
    // TODO :: AF-587 We need to have a outcome_date per animal and not per outcome
    fieldsSettings!.outcome_date!.settings!.minDate = new Date(oldestIntakeDate);

    fieldsSchema.value = getDetailsSchema(rawFields.value, fieldsSettings);
  }

  return {
    currentSchemaModels,
    fieldsSchema,
    rawFields,
    setForm,
  };
}
